import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronRight, LifeBuoy, Rocket, ShieldCheck, Sparkles } from "lucide-react";
import { practiceApi } from "../../lib/practiceApi";
import { ReleaseItem, releaseDate } from "./ReleaseDialog";
import "./releases.css";

const PLAN_LABELS = { pro: "ingego Pro", trial: "ingego Pro in prova", standard: "ingego Standard" };

/** Centro Informazioni: dati dell'applicazione, dello studio e storico completo degli aggiornamenti. */
export const InfoCenter = ({ studio = {}, go = () => {} }) => {
  const [releases, setReleases] = useState([]);
  const [plan, setPlan] = useState(null);
  const [open, setOpen] = useState("");
  useEffect(() => {
    practiceApi("/releases").then(rows => { setReleases(rows); setOpen(rows[0]?.id || ""); }).catch(() => setReleases([]));
    practiceApi("/plan").then(setPlan).catch(() => setPlan(null));
  }, []);
  const current = releases.find(release => release.status === "PUBBLICATA") || releases[0];
  const info = [
    ["Applicazione", "ingego · Engineering, organized."],
    ["Versione in uso", current ? `v${current.version} · ${releaseDate(current.date)}` : "—"],
    ["Piano attivo", plan ? (PLAN_LABELS[plan.plan] || plan.plan) : "—"],
    ["Aggiornamenti pubblicati", String(releases.filter(release => release.status === "PUBBLICATA").length)],
    ["Studio", studio.brand_title || studio.office || studio.name || "—"],
    ["Professionista", studio.name || "—"],
    ["Email", studio.email || "—"],
    ["PEC", studio.pec || "—"],
    ["Telefono", studio.phone || "—"],
    ["Iscrizione all'ordine", studio.register || "—"],
  ];
  return <div className="info-center" data-testid="info-center">
    <div className="info-grid" data-testid="info-app">
      {info.map(([label, value]) => <div key={label}>
        <span>{label}</span>
        <strong data-testid={`info-value-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{value}</strong>
      </div>)}
    </div>

    <div className="info-links">
      <a href="/privacy" target="_blank" rel="noopener noreferrer" data-testid="info-privacy"><ShieldCheck size={15} />Privacy</a>
      <a href="/termini" target="_blank" rel="noopener noreferrer" data-testid="info-terms"><ShieldCheck size={15} />Termini di servizio</a>
      <a href="/supporto" target="_blank" rel="noopener noreferrer" data-testid="info-support"><LifeBuoy size={15} />Supporto</a>
      <a href="/prezzi" target="_blank" rel="noopener noreferrer" data-testid="info-pricing"><Sparkles size={15} />Piani e prezzi</a>
    </div>

    <header className="release-center-head">
      <span className="release-mark"><Rocket size={18} /></span>
      <div>
        <p className="eyebrow">LOG AGGIORNAMENTI</p>
        <h2>Tutte le novità pubblicate</h2>
        <p className="muted">Dalla più recente: apri una versione per leggere le modifiche.</p>
      </div>
    </header>
    {!releases.length && <p className="muted" data-testid="info-releases-empty">Nessun aggiornamento pubblicato.</p>}
    {releases.map(release => <section className="release-entry" key={release.id} data-testid={`release-entry-${release.version}`}>
      <button className="release-entry-head" data-testid={`release-toggle-${release.version}`}
        onClick={() => setOpen(open === release.id ? "" : release.id)}>
        {open === release.id ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
        <strong>v{release.version}</strong>
        <span className="muted">{releaseDate(release.date)}</span>
        <em>{release.title}</em>
        {release.status !== "PUBBLICATA" && <span className="release-badge corretto">BOZZA</span>}
        {!release.seen && release.status === "PUBBLICATA" && <span className="release-badge nuovo">DA LEGGERE</span>}
      </button>
      {open === release.id && <ul className="release-list">
        {(release.items || []).map((item, index) => <ReleaseItem key={item.id || `item-${index}`}
          item={{ ...item, id: item.id || `item-${index}` }} go={go} />)}
      </ul>}
    </section>)}
  </div>;
};
